module.exports = __webpack_public_path__ + "img/V10.728f476c.jpg";